export default () => {
  let token = null;

  try {
    const storage = JSON.parse(localStorage.openbooksmd);

    token = storage.token.data.token;
  } finally {
    return token;
  }
};



// WEBPACK FOOTER //
// ./app/lib/jwtFromLocalStorage.js